import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_ALL_PLAN_REQUEST = 'plan/FETCH_ALL_PLAN_REQUEST'
const FETCH_ALL_PLAN_SUCCESS = 'plan/FETCH_ALL_PLAN_SUCCESS'
const FETCH_ALL_PLAN_FAILURE = 'plan/FETCH_ALL_PLAN_FAILURE'

const FETCH_IS_ACTIVE_PLAN_REQUEST = 'plan/FETCH_IS_ACTIVE_PLAN_REQUEST'
const FETCH_IS_ACTIVE_PLAN_SUCCESS = 'plan/FETCH_IS_ACTIVE_PLAN_SUCCESS'
const FETCH_IS_ACTIVE_PLAN_FAILURE = 'plan/FETCH_IS_ACTIVE_PLAN_FAILURE'

const CREATE_PLAN_REQUEST = 'plan/CREATE_PLAN_REQUEST'
const CREATE_PLAN_SUCCESS = 'plan/CREATE_PLAN_SUCCESS'
const CREATE_PLAN_FAILURE = 'plan/CREATE_PLAN_FAILURE'

const UPDATE_PLAN_REQUEST = 'plan/UPDATE_PLAN_REQUEST'
const UPDATE_PLAN_SUCCESS = 'plan/UPDATE_PLAN_SUCCESS'
const UPDATE_PLAN_FAILURE = 'plan/UPDATE_PLAN_FAILURE'

const DELETE_PLAN_REQUEST = 'plan/DELETE_PLAN_REQUEST'
const DELETE_PLAN_SUCCESS = 'plan/DELETE_PLAN_SUCCESS'
const DELETE_PLAN_FAILURE = 'plan/DELETE_PLAN_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  planList: [],
  planIsActiveList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        planList: action.payload
      }
    case FETCH_ALL_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_IS_ACTIVE_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_IS_ACTIVE_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        planIsActiveList: action.payload
      }
    case FETCH_IS_ACTIVE_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export const getAllPlanList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await API.get(EndPoints.PLAN, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: FETCH_ALL_PLAN_SUCCESS,
        payload: response.data
      })
    } catch (error) {
      dispatch({
        type: FETCH_ALL_PLAN_FAILURE
      })
    }
  }
}

export const getIsActivePlanList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_IS_ACTIVE_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await API.get(EndPoints.PLAN + '/isActive', {
        headers: {
          Authorization: authorizationHeader
        }
      })
      console.log('response getIsActivePlanList:', response)
      console.log('response.data getIsActivePlanList:', response.data)

      dispatch({
        type: FETCH_IS_ACTIVE_PLAN_SUCCESS,
        payload: response.data
      })
    } catch (error) {
      dispatch({
        type: FETCH_IS_ACTIVE_PLAN_FAILURE
      })
    }
  }
}

export const createPlan = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.PLAN, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: CREATE_PLAN_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_PLAN_FAILURE
      })
    }
  }
}

export const updatePlan = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.PLAN, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: UPDATE_PLAN_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_PLAN_FAILURE
      })
    }
  }
}

export const deletePlan = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.PLAN + '/' + id, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: DELETE_PLAN_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_PLAN_FAILURE
      })
    }
  }
}
